<template>
  <div class="addr-videos">
    <el-table v-if="rows.length" :data="rows" size="small" stripe max-height="360">
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="通道" width="80">
        <template slot-scope="scope">CH{{ scope.row.channel }}</template>
      </el-table-column>
      <el-table-column label="时间" min-width="280">
        <template slot-scope="scope">
          {{ scope.row.videoStart | dateFormat("yyyy-MM-dd HH:mm:ss") }}
          -
          {{ scope.row.videoEnd | dateFormat("HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column label="下载状态" width="90">
        <template slot-scope="scope">{{ statusText(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="下载" width="90">
        <template slot-scope="scope">
          <el-link v-if="canDownload(scope.row)" type="primary" :href="downloadUrl(scope.row)"
            target="_blank">直接下载</el-link>
          <span v-else class="link-disabled">直接下载</span>
        </template>
      </el-table-column>
      <el-table-column label="说明" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ tipText(scope.row) }}</template>
      </el-table-column>
    </el-table>
    <div v-else class="empty">暂无录像，请稍候或该时段无录像</div>
  </div>
</template>
<script>
import { DateUtil } from "@/util";

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    route: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    rows() {
      return [...this.list].sort((a, b) => {
        const timeA = a.videoStart || a.createTime || "";
        const timeB = b.videoStart || b.createTime || "";
        if (timeA !== timeB) {
          return String(timeA).localeCompare(String(timeB));
        }
        return (a.channel || 0) - (b.channel || 0);
      });
    }
  },

  methods: {
    canDownload(row) {
      return /^https?:/i.test(row.url || "");
    },

    statusText(row) {
      if (this.canDownload(row)) {
        return "已下载";
      }
      if (row.errMsg) {
        return "失败";
      }
      return "下载中";
    },

    tipText(row) {
      if (row.errMsg) {
        return row.errMsg;
      }
      if (this.canDownload(row)) {
        return "下载后本地播放";
      }
      return "录像还在下载";
    },

    downloadUrl(row) {
      const url = row.url || "";
      if (!this.canDownload(row)) {
        return "";
      }
      const key = "&SAVENAME=";
      const index = url.indexOf(key);
      if (index < 0) {
        return url;
      }
      const driverNo = this.route.driverNo || "";
      const start = this.nameTime(row.videoStart, "MM月dd日 hh:mm:ss");
      const end = this.nameTime(row.videoEnd, "hh:mm:ss");
      const saveName = `${driverNo}_CH${row.channel}_${start} - ${end}.mp4`;
      return url.substring(0, index) + key + saveName;
    },

    nameTime(value, pattern) {
      if (!value) {
        return "";
      }
      const date = new Date(String(value).replace(" ", "T"));
      if (Number.isNaN(date.getTime())) {
        return String(value);
      }
      return DateUtil.format(date, pattern);
    }
  }
};
</script>
<style scoped lang="less">
.addr-videos {
  margin: 0 10px 12px;
}

.empty {
  padding: 24px 0;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.link-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>
